import * as React from 'react';
export const loomSvg = React.forwardRef(function loomSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fill: '#625DF5',
      d: 'M0 0h32v32H0z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M28 14.665h-7.018l6.078-3.509-1.335-2.312-6.078 3.509 3.509-6.077-2.313-1.336-3.508 6.077V4h-2.67v7.018l-3.51-6.078-2.311 1.335 3.509 6.077-6.078-3.508-1.335 2.312 6.078 3.509H4v2.67h7.017L4.94 20.843l1.335 2.312 6.077-3.508-3.509 6.077 2.313 1.335 3.508-6.078V28h2.67v-7.017l3.508 6.077 2.313-1.335-3.51-6.078 6.079 3.51 1.335-2.313-6.078-3.509H28v-2.67Zm-12 4.966a3.645 3.645 0 1 1 0-7.29 3.645 3.645 0 0 1 0 7.29Z',
      fill: '#fff',
    }),
  );
});
loomSvg.defaultProps = {
  width: '32',
  height: '32',
  viewBox: '0 0 32 32',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var loom = {
  category: 'brand',
  colorable: false,
  name: 'loom',
  svg: loomSvg,
};
